import { render, staticRenderFns } from "./teachManagement.vue?vue&type=template&id=aff54f9c&scoped=true&"
var script = {}
import style0 from "./teachManagement.vue?vue&type=style&index=0&id=aff54f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff54f9c",
  null
  
)

export default component.exports